var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKissSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 658.432 312.661 c -80.4409 0 -125.042 46.1938 -140.061 65.4222 c -2.84445 3.52711 -8.192 3.52711 -10.9227 0 c -15.0187 -19.2285 -59.6195 -65.4222 -140.061 -65.4222 c -82.6027 0 -258.845 136.875 -326.542 186.027 c -7.73689 5.68889 -17.408 9.10222 -25.0311 11.0365 c -5.34755 1.36533 -7.05422 8.07822 -2.95822 11.8329 c 36.7502 33.792 167.481 150.869 281.259 209.579 c 103.538 53.4755 218.795 54.7271 218.795 54.7271 s 115.257 -1.25155 218.795 -54.7271 c 112.754 -58.2542 242.347 -173.853 280.349 -208.782 c 3.98222 -3.64089 2.50311 -10.24 -2.73067 -11.8329 c -6.25778 -1.82045 -14.336 -5.34755 -24.1209 -12.288 c -76.3449 -54.7271 -248.946 -185.571 -326.77 -185.571 Z",
    fill: "#494668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 312.206 543.289 c -3.98222 -1.82045 -3.072 -7.62311 1.25155 -8.07822 c 31.1751 -3.75467 108.999 -11.8329 198.77 -9.44355 c 88.7467 2.27555 167.481 10.6951 200.021 14.5635 c 4.43733 0.568889 5.23378 6.59911 1.024 8.192 c -32.3129 12.8569 -112.413 41.1875 -194.674 43.2355 c -84.4231 2.048 -173.397 -33.6782 -206.393 -48.4693 Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKissSvgrepoCom);
export default __webpack_public_path__ + "static/media/kiss-svgrepo-com.d1322832ccc0d5d9217d7b179bdfbbe0.svg";
export { ForwardRef as ReactComponent };